var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.748 6.822 4.63-3.969a.955.955 0 0 1 1.243 0l4.631 3.97",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.669 12.252V2.623a.292.292 0 0 0-.292-.292h-1.75a.292.292 0 0 0-.293.292v1.521M5.568 12.252v-3.21c0-.322.26-.583.583-.583H7.85c.322 0 .583.261.583.584v3.21M2.498 6.18v6.072M12.252 12.252H1.748",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseNew);
export default __webpack_public_path__ + "static/media/house-new.a35e621bb6f203200b334a7319c2642f.svg";
export { ForwardRef as ReactComponent };